<random-background class="success-bg"></random-background>

<div class="success-fg" [class.dark]="darkMode">
  <ng-content></ng-content>
</div>
